import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { IStateTree } from "../../store/interfaces";
import { IUser, RhythmSyllableType } from "../../store/user/models";

import { P2, H4, H3 } from "../styles";
import messages from "./messages";
import FormattedHtmlMessage from "../../../common/helpers/FormattedHtmlMessage";

const RhytLadderArticle = () => {
    const rhythmSyllableType = useSelector((state: IStateTree) => (state.user as IUser).rhythmSyllableType || RhythmSyllableType.Kodaly)
    return (
        <>
            <H3>
                <FormattedMessage {...messages.title} />
            </H3>
            <H4 center>
                <FormattedHtmlMessage {...messages.slogen} />
            </H4>
            <P2 center>
                <FormattedHtmlMessage {...messages.description} />
            </P2>
            {rhythmSyllableType !== RhythmSyllableType.Kodaly &&
                rhythmSyllableType !== RhythmSyllableType.KodalyTiRi &&
                rhythmSyllableType !== RhythmSyllableType.KodalyTeTe &&
                rhythmSyllableType !== RhythmSyllableType.KodalyRiRiTaiTi &&
                rhythmSyllableType !== RhythmSyllableType.KodalyTiRiTaiTi && (
                    <P2 alert center>
                        <FormattedMessage {...messages.notKodaly} />
                    </P2>
                )}
        </>
    );
}

export default RhytLadderArticle;
